import { concat } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';

export default class RecordExplorerToolbarFiltersSelectCustomComponent extends Component {
  // Services
  @service intl;

  // Getter and setter
  get options() {
    let recordType = this.args.recordType;
    let scope = `tables.${recordType}.filterOptions`;
    let filter = this.args.filter;

    return filter.options.map((option) => {
      return {
        label: this.intl.t(`${scope}.${option.property}`),
        property: option.property,
        value: option.value,
      };
    });
  }

  get selected() {
    return this.options.find((option) => {
      let value = this.args.activeFilters[option.property];

      return value || value === 0;
    });
  }

  // Functions
  setFilter = (selected, { options }) => {
    let filters = this.args.activeFilters;

    options.forEach((option) => {
      delete filters[option.property];
    });

    if (selected) {
      filters[selected.property] = selected.value;
    }

    this.args.onChangeFilter(filters);
  };

  // Template
  <template>
    <PowerSelect
      @allowClear={{true}}
      @options={{this.options}}
      @selected={{this.selected}}
      @searchEnabled={{true}}
      @searchField='label'
      @placeholder={{t
        'tables.placeholder-filter'
        filter=(t (concat 'tables.filters.' @filter.key))
      }}
      @onChange={{this.setFilter}}
      as |option|
    >
      {{option.label}}
    </PowerSelect>
  </template>
}
